<template>
  <v-card flat class="rounded-xl overflow-hidden pa-8">
    <vue-table
      :data="tableData"
      :headers="headers"
      :loading="loading"
      @change="onPagination"
    >
      <!-- فیلترهای بالای جدول -->
      <template v-slot:filters="{ props, perPage }">
        <v-row no-gutters class="mb-4">
            <v-col class="pa-2" cols="12" lg="2" md="3">
                    <v-select
                      v-model="props.length"
                      :items="perPage"
                      class="rounded-lg"
                      dense
                      hide-details
                      :label="$t('qrUsersList.perPage')"
                      outlined
                      @change="() => onPagination(props)"
                    />
                  </v-col>      
                  <v-col class="pa-2" cols="12" lg="2" md="3">
                    <v-select
                      v-model="props.column"
                      :items="columnOptions"
                      label="مرتب‌سازی براساس"
                      dense
                      hide-details
                      outlined
                      class="rounded-lg"
                      @change="() => onPagination(props)"
                    />
                  </v-col>
                  <v-col class="pa-2" cols="12" lg="2" md="3">
                    <v-select
                      v-model="props.dir"
                      :items="dirOptions"
                      label="جهت مرتب‌سازی"
                      dense
                      hide-details
                      outlined
                      class="rounded-lg"
                      @change="() => onPagination(props)"
                    />
                  </v-col>
          <v-col class="pa-2" cols="12" md="3">
            <v-text-field
              v-model="props.search"
              append-icon="mdi-magnify"
              label="جستجو در نام محصول..."
              outlined dense hide-details clearable
              @keyup.enter="() => onPagination(props)"
            />
          </v-col>
        </v-row>
      </template>
        <template v-slot:index="{item}">
            {{ persian(item.index + 1 + (tableData.current_page - 1) * tableData.per_page) }}
        </template>


      <!-- تصویر محصول -->
      <template v-slot:image_src="{ item }">
        <v-img :src="item.image_src" max-width="80" class="rounded-lg mx-auto" />
      </template>
      <template v-slot:updated_at="{ item }">
        {{jalalian(item.updated_at,"datetime")}}
      </template>
      <!-- اطلاعات محصول -->
      <template v-slot:product_info="{ item }">
        <div class="text-right">
          <div class="font-weight-bold mb-1">{{ item.title }}</div>
          <div class="caption grey--text">کد کالا: {{ item.product_id }}
                      <v-btn icon small @click.stop="copyID(item.product_id)" class="ms-2" color="#B5C5FD">
            <v-icon small>mdi-content-copy</v-icon>
          </v-btn>
          </div>
          <v-chip x-small color="blue-grey lighten-5" class="mt-1">
            {{ item.category_title }}
          </v-chip>
        </div>
      </template>

      <!-- تعداد تنوع -->
      <template v-slot:variants_count="{ item }">
        <v-chip small color="primary" outlined>{{ item.variants_count || 0 }} تنوع</v-chip>
      </template>

      <!-- عملیات -->
      <template v-slot:action="{ item }">
        <div @click.stop.prevent @mousedown.stop.prevent>
        <action-buttons :data="item" :meta="metabutton"/>
        </div>
      </template>
    </vue-table>

    <product-variants-modal 
      v-model="showVariantsModal" 
      :product="selectedProduct" 
    />
  </v-card>
</template>

<script>
import ActionButtons from "@/view/components/adapters/qrList/ordersListButton.vue";
import ProductVariantsModal from "./ProductVariantsManager.vue";

export default {
  name: "DigiProducts",
  components: { ProductVariantsModal,ActionButtons },
  computed:{
        metabutton() {
      return {
        buttons: [
          {
            name: "openVariants",
            label: "مدیریت تنوع‌ها",
            icon: "layers-triple-outline",
            class: "btn-buy rounded-pill",
            action: this.openVariants,
          },
        ],
      };
    },

  },
  data: () => ({
    loading: false,
    showVariantsModal: false,
    selectedProduct: null,
    tableData: { data: [], total: 0, current_page: 1, per_page: 10 },
    headers: [
        
      { value: 'index', text: 'ردیف', align: 'center', sortable: false },
      { value: 'image_src', text: 'تصویر', align: 'center', sortable: false },
      { value: 'product_info', text: 'مشخصات محصول', align: 'right', sortable: false },
      { value: 'variants_count', text: 'تعداد تنوع', align: 'center' },
    //   { value: 'created_at_p', text: 'تاریخ ثبت', align: 'center' },
      { value: 'updated_at', text: 'تاریخ به روزرسانی', align: 'center' },
      { value: 'action', text: 'عملیات', align: 'center', sortable: false },
    ],
    tableProps: { page: 1, length: 10, search: null, dir: 'desc', column: 'updated_at'},
    	 columnOptions: [
      { text: "تعداد تنوع", value: "variants_count" },
      { text: "شناسه محصول", value: "id" },
      { text: "تاریخ بروزرسانی", value: "updated_at" },

    ],
    dirOptions: [
      { text: "نزولی", value: "desc" },
      { text: "صعودی", value: "asc" }
    ],


  }),
  mounted() {
    this.fetchProducts();
  },
  methods: {
    	copyID(textToCopy) {
      const text = String(textToCopy); 
      
      if (navigator.clipboard) {
        navigator.clipboard
          .writeText(text)
          .then(() => {
            this.$toast.success("با موفقیت کپی شد");
          })
          .catch((err) => {
            console.error("Clipboard error:", err);
            this.$toast.error("خطا در کپی");
          });
      } else {
        const textarea = document.createElement("textarea");
        textarea.value = text;
        document.body.appendChild(textarea);
        textarea.select();
        document.execCommand("copy");
        document.body.removeChild(textarea);
        this.$toast.success("با موفقیت کپی شد");
      }
    },
    async fetchProducts() {
      this.loading = true;
      try {
        const res = await this.$api.get('/v1/digikala/products', { params: this.tableProps });
        this.tableData = res.data.data;
      } catch (e) {
        this.$toast.error("خطا در دریافت لیست محصولات");
      } finally {
        this.loading = false;
      }
    },
    onPagination(e) {
      this.tableProps = { ...this.tableProps, ...e };
      this.fetchProducts();
    },
    openVariants(product) {
      this.selectedProduct = product;
      this.showVariantsModal = true;
    }
  }
};
</script>
